import { withInstall } from '@jdesign-vue/utils'

import Card from './src/card.vue'

export const JdCard = withInstall(Card)
export default JdCard

export * from './src/card'
export type { CardInstance } from './src/instance'
